import styles from "./textfield.module.css";
import { useEffect, useState } from "react";
import classNames from "classnames";

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  validation?: (value: string) => string | undefined; //Error messaage or no error.
  onChangeText?: (value: string) => void;
}

export const TextField: React.FC<TextFieldProps> = ({
  title,
  validation,
  onChangeText,
  className,
  ...rest
}) => {
  const [value, setValue] = useState<string>(rest.value?.toString() || "");
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (validation) {
      setError(validation(value as string));
    }
  }, [value, validation]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value); // Update local value state
    if (onChangeText) {
      onChangeText(e.target.value); // Call parent-provided onChangeText
    }
  };

  return (
    <div className={styles.container}>
      {title && (
        <span
          className={classNames(
            styles.title,
            isFocused ? styles.titleFocused : ""
          )}
        >
          {title}
        </span>
      )}
      <input
        className={classNames(
          styles.textField,
          className,
          error ? styles.textFieldError : ""
        )}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={handleChange}
        {...rest}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};
